/**
 * Autore: Salvo de Luca
 * Azienda Dialogicom s.r.l.s.
 * File: src/components/auth/ResetPasswordPage.tsx
 * Release: v2.0.0 - Pagina Reset Password
 */

import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const ResetPasswordPage: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [code, setCode] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);
  const API_BASE = import.meta.env.DEV ? 'http://localhost:3002/api' : '/api';

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const e = params.get('email') || '';
    const c = params.get('code') || '';
    setEmail(decodeURIComponent(e));
    setCode(c);
  }, [location.search]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setSuccess(null);
    if (!password || password.length < 8) {
      setError('La password deve essere di almeno 8 caratteri');
      return;
    }
    if (password !== confirm) {
      setError('Le password non coincidono');
      return;
    }
    try {
      const resp = await fetch(`${API_BASE}/auth/reset-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ email, code, newPassword: password })
      });
      const data = await resp.json().catch(() => ({}));
      if (!resp.ok || !data?.success) {
        setError(data?.error || 'Impossibile reimpostare la password');
        return;
      }
      setSuccess('Password aggiornata correttamente. Ora puoi accedere.');
      setTimeout(() => navigate('/sign-in', { replace: true }), 2000);
    } catch (err) {
      setError('Errore di connessione');
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-900 text-white p-4">
      <div className="bg-slate-800 p-6 rounded-xl shadow-xl w-full max-w-md">
        <h1 className="text-2xl font-bold mb-4">Reimposta Password</h1>
        {email && code ? (
          <form onSubmit={handleSubmit} className="space-y-3">
            <div className="text-sm text-gray-400">Email: <span className="text-gray-200">{email}</span></div>
            <input
              type="password"
              placeholder="Nuova password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              className="w-full px-3 py-2 border rounded bg-slate-900 text-white border-slate-700"
              autoComplete="new-password"
              required
            />
            <input
              type="password"
              placeholder="Conferma password"
              value={confirm}
              onChange={e => setConfirm(e.target.value)}
              className="w-full px-3 py-2 border rounded bg-slate-900 text-white border-slate-700"
              autoComplete="new-password"
              required
            />
            {error && <p className="text-red-400 text-sm">{error}</p>}
            {success && <p className="text-green-400 text-sm">{success}</p>}
            <button type="submit" className="w-full bg-green-600 hover:bg-green-500 py-2 rounded">Reimposta</button>
          </form>
        ) : (
          <p className="text-red-400">Link non valido o incompleto.</p>
        )}
      </div>
    </div>
  );
};

export default ResetPasswordPage;






